export default "__VITE_ASSET__DOfGdlsm__"